"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ApiWaveCreditType } from "@/generated/models/ApiWaveCreditType";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
import CommonBorderedRadioButton from "@/components/utils/radio/CommonBorderedRadioButton";
import CreateWaveVotingRep from "./CreateWaveVotingRep";
import NegativeVotingToggle from "./NegativeVotingToggle";
import TimeWeightedVoting from "./TimeWeightedVoting";
import { TimeWeightedVotingConfig } from "./types";
export default function CreateWaveVoting(t0) {
  const $ = _c(29);
  const {
    waveType,
    selectedType,
    category,
    profileId,
    errors,
    onTypeChange,
    setCategory,
    setProfileId,
    timeWeighted,
    onTimeWeightedChange
  } = t0;
  const [allowNegativeVotes, setAllowNegativeVotes] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiWaveType.Chat]: "How Drops are Rated",
      [ApiWaveType.Rank]: "How Drops are Voted",
      [ApiWaveType.Approve]: "How Drops are Voted"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const TITLES = t1;
  if (!selectedType) {
    return null;
  }
  const t2 = TITLES[waveType];
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50">{t2}</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = Object.values(ApiWaveCreditType);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onTypeChange || $[5] !== selectedType) {
    t5 = t4.map(votingType => <CommonBorderedRadioButton key={votingType} type={votingType} selected={selectedType} disabled={false} label={WAVE_VOTING_LABELS[votingType]} onChange={onTypeChange} />);
    $[4] = onTypeChange;
    $[5] = selectedType;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== category || $[8] !== errors || $[9] !== profileId || $[10] !== selectedType || $[11] !== setCategory || $[12] !== setProfileId) {
    t6 = selectedType === ApiWaveCreditType.Rep && <div className="tw-col-span-full"><CreateWaveVotingRep category={category} profileId={profileId} errors={errors} setCategory={setCategory} setProfileId={setProfileId} /></div>;
    $[7] = category;
    $[8] = errors;
    $[9] = profileId;
    $[10] = selectedType;
    $[11] = setCategory;
    $[12] = setProfileId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="tw-mt-3 tw-grid lg:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-4">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== allowNegativeVotes || $[18] !== waveType) {
    t8 = waveType !== ApiWaveType.Chat && <NegativeVotingToggle allowNegativeVotes={allowNegativeVotes} onChange={setAllowNegativeVotes} />;
    $[17] = allowNegativeVotes;
    $[18] = waveType;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== onTimeWeightedChange || $[21] !== timeWeighted || $[22] !== waveType) {
    t9 = waveType === ApiWaveType.Rank && <TimeWeightedVoting config={timeWeighted} onChange={onTimeWeightedChange} />;
    $[20] = onTimeWeightedChange;
    $[21] = timeWeighted;
    $[22] = waveType;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t3 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t10 = <div>{t3}{t7}{t8}{t9}</div>;
    $[24] = t3;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}